import { Component, Input } from '@angular/core';
import { EdocAddedBanner } from './data-models/edoc-added-banner.interface';

@Component({
  selector: 'idp-edoc-added-banner',
  templateUrl: './edoc-added-banner.component.html',
  styleUrls: ['./edoc-added-banner.component.scss']
})
export class EdocAddedBannerComponent {
  @Input() config: EdocAddedBanner = {} as EdocAddedBanner;
}
